import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

const NoInfoLayout = ({ children, heading, title }) => (
  <>
    <Box contain>
      <Typography
        color="neutral"
        fontSize="14px"
        light
        mx={{ _: 2, tablet: "auto" }}
        my={3}
        textAlign="left"
      >
        <Link data-lc="no-info-layout" to="/">
          Home
        </Link>{" "}
        / {heading || title}
      </Typography>
    </Box>
    {children}
  </>
)

NoInfoLayout.propTypes = {
  children: PropTypes.element.isRequired,
  description: PropTypes.string,
  heading: PropTypes.string,
  layout: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default NoInfoLayout
